<template>
  <div>
    <ui-modal
      ref="modal"
      title="Visualizador de Bills of Lading"
      class="modal-BL"
      @close="ActionSetVisibleModalBL(false), ActionSetZindexTablaModal(false)">
      <BuscarBLPage />
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";
// Keen UI
import UiModal from "keen-ui/src/UiModal";
// Componentes
import BuscarBLPage from "../../../../views/lineas/BuscarBLPage";

export default {
  data() {
    return {
      acciones: [],
      detalleBuscarBL: []
    };
  },
  components: {
    BuscarBLPage,
    UiModal
  },
  computed: {
    ...mapState(["visibleModalBL"])
  },
  methods: {
    ...mapActions([
      "ActionSetVisibleModalBL",
      "ActionSetZindexTablaModal"
    ]),
    ...mapActions("lineas", [
      "actionSetDataResultadoBooking",
      "actionSetDataResultadoContainers",
      "actionSetDataResultadoBillLadings",
      "actionSetBlSearchCarrierBookingNumber"
    ]),
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    }
  },
  watch: {
    visibleModalBL: function(_new) {
      if (_new) {

        this.openModal("modal");

      } else {

        this.actionSetDataResultadoBooking([]);
        this.actionSetDataResultadoContainers([[]]);
        this.actionSetDataResultadoBillLadings([]);
        this.actionSetBlSearchCarrierBookingNumber("")

      }
    }
  }
};
</script>
<style>
.modal-BL .ui-modal__container {
    width: 90% !important;
    height: 90% !important;
}

.header {
    height: 30px !important;
}
</style>
